import * as React from "react";
function SvgCartArrowDownSolid(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M19.525 14.222H9.346l.228 1.111h9.32c.534 0 .93.497.812 1.018l-.191.843a1.945 1.945 0 01-.877 3.695 1.952 1.952 0 01-1.915-1.89 1.938 1.938 0 01.583-1.444h-7.28a1.945 1.945 0 11-2.328-.297L5.261 5.333H2.833A.833.833 0 012 4.5v-.556c0-.46.373-.833.833-.833h3.56c.396 0 .737.279.817.666l.318 1.556h13.638c.535 0 .931.497.813 1.018l-1.642 7.223a.833.833 0 01-.812.648zm-3.53-4.444H14.5V7.694a.417.417 0 00-.417-.416h-.833a.417.417 0 00-.417.416v2.084H11.34a.417.417 0 00-.294.711l2.327 2.327a.417.417 0 00.59 0l2.327-2.327a.417.417 0 00-.295-.711z"
        fill="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCartArrowDownSolid);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
